









































import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import ItemCard from '@/components/molecules/ItemCard.vue'
import { State as ticketsState, Tickets } from '@/store/modules/tickets'

export default Vue.extend({
  name: 'ItemList',
  components: {
    SimpleLoader,
    PageTitle,
    SectionTitle,
    ItemCard
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.tickets.isTicketsLoading
    },
    tickets(): ticketsState['tickets'] | null {
      return this.$state.tickets.tickets
    },
    unUsedTickets(): Tickets[] | null {
      return this.tickets ? this.tickets.tickets.filter((ticket: Tickets) => ticket.state === 'issued') : null
    },
    usedTickets(): Tickets[] | null {
      return this.tickets ? this.tickets.tickets.filter((ticket: Tickets) => ticket.state !== 'issued') : null
    }
  },
  methods: {
    hasUsed(state: string): boolean {
      return state !== 'issued'
    },
    handleClick({ id, hasUsed, usedAt }: { id: string; hasUsed: boolean; usedAt: string }) {
      this.$store.dispatch('tickets/setTicketId', { id })
      if (hasUsed) {
        this.$store.dispatch('tickets/setTicketUsedAt', { usedAt })
      }
      this.$store.dispatch('benefits/setUsedFrag', { hasUsed })
    }
  },
  mounted() {
    this.$store.dispatch('tickets/closeUsedTickets')
    this.$store.dispatch('tickets/fechTickets')
  }
})
